import axios from 'axios';

const API_URL_PROD = 'http://192.168.100.223:8080/prova-cotas-iaupe-api/api/candidato'
const API_URL_LOCAL = 'http://ht.iaupevirtual.com.br:8080/prova-cotas-iaupe-api/api/candidato'

class ProvaCandidatoService{

  cadastrarProva(provaRequest, nomeEnviado, cpfEnviado, dataNascimentoEnviado, numeroInscricao){
    return axios.post(`${API_URL_LOCAL}/cadastrar-prova`, provaRequest, {
      params: {
        nome: nomeEnviado,
        cpf: cpfEnviado,
        dataNascimento: dataNascimentoEnviado,
        numeroInscricao: numeroInscricao
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }})
  }

  cadastrarProvaInscricaoConcluida(provaRequest, cpfEnviado, numeroInscricao){
    return axios.post(`${API_URL_LOCAL}/cadastrar-prova-inscricao-concluida`, provaRequest, {
      params: {
        cpf: cpfEnviado,
        numeroInscricao: numeroInscricao
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }})
  }

  getConcursoData(idConcurso){
    return axios.get(`${API_URL_LOCAL}/concurso/${idConcurso}`);
  }

  getCandidatoData(numeroInscricao){
    return axios.get(`${API_URL_LOCAL}/${numeroInscricao}`);
  }

}

export default new ProvaCandidatoService();